export function useLocalDate() {
	return {
		format: (date: string | Date) => new Date(date).toLocaleDateString("fi-FI"),
	};
}
